import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import * as actions from "../../actions";
import { useLocation } from "react-router-dom";
import * as Template from "../../templates";

export default () => {

  const moduleName = "periodics";
  const location = useLocation()
  const appReducer = useSelector((state) => state.appReducer);
  const dispatch = useDispatch();
  const [rows, setRows] = useState([])
  const [totalPages, setTotalPages] = useState(0)

  const handleDelete = id => dispatch(actions.destroy(id, moduleName))

  useEffect(() => {
    dispatch(actions.list(moduleName, location.search));
  }, [appReducer.periodics_destroy, location.search]);

  useEffect(() => {
    if (appReducer.periodics_list != undefined) {
      setRows(appReducer.periodics_list.data)
      setTotalPages(appReducer.periodics_list.count)
    }
  }, [appReducer])


  const columns = [
    {
      name: 'نام',
      selector: row => row.name ?? "-",
    },
    {
      name: 'زمان بعد از خرید کاربر',
      selector: row => `${row.hour} دقیقه`,
    },
    {
      name: 'پیام',
      selector: row => row.message ?? "-",
    },
    {
      name: 'وضعیت سفارش',
      selector: row => {

        let invoiceState = "در حال بررسی"

        switch (row.state) {
          case "cancelled":
            invoiceState = "لغو شده"
            break;
          case "preview":
            invoiceState = "پیش‌ فاکتور"
            break;
          case "waiting":
            invoiceState = "در حال بررسی"
            break;
          case "accept":
            invoiceState = "تایید شده"
            break;
          case "trash":
            invoiceState = "زباله‌دان"
            break;
          case "packaging":
            invoiceState = "بسته‌بندی"
            break;
          case "stopped":
            invoiceState = "متوقف‌شده"
            break;
          case "preparation":
            invoiceState = "آماده‌سازی"
            break;
          case "ready_to_send":
            invoiceState = "آماده ارسال"
            break;
          case "peyk":
            invoiceState = "تحویل پیک"
            break;
          case "sent":
            invoiceState = "ارسال شده"
            break;
          case "post":
            invoiceState = "تحویل اداره پست"
            break;
          case "delivered":
            invoiceState = "پایان مراحل"
            break;
          case "customer_blocked":
            invoiceState = "عدم پاسخگویی"
            break;
          case "considering":
            invoiceState = "بررسی بیشتر"
            break;
        }

        return invoiceState
      },
    },
    {
      name: 'تاریخ ایجاد',
      selector: row => row.created_at,
    },
    {
      name: 'عملیات',
      selector: row => <Template.TableButton handleDelete={() => handleDelete(row.id)} row={row} location={location} />,
    },
  ];

  return <Template.Table count={totalPages} columns={columns} data={rows} />;

};
